import { render, staticRenderFns } from "./NotificationsProvider.vue?vue&type=template&id=11fde1a6&"
import script from "./NotificationsProvider.vue?vue&type=script&lang=js&"
export * from "./NotificationsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports